import { useParams } from "react-router-dom";
import { getExam, useGetExamQuestionDetails } from "src/hooks/useExam";
import { useQuestionSettings } from "src/reducers/exam";

import OptionDetails from "./index";

export function ExamOptionDetails() {
	const { id } = useParams();
	const { question, folders } = getExam(id);
	const { state, dispatch } = useQuestionSettings();
	const { data: details = {} } = useGetExamQuestionDetails(question.id, id);

	return (
		<OptionDetails
			question={question}
			folders={folders}
			state={state}
			dispatch={dispatch}
			details={details}
		/>
	);
}
